import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { InitOptions } from 'i18next';

// Define translations directly
const resources = {
  en: {
    translation: require('./locales/en/translation.json')
  },
  fr: {
    translation: require('./locales/fr/translation.json')
  }
};

// Define initialization options with proper typing
const initOptions: InitOptions = {
  resources,
  fallbackLng: 'fr',
  debug: process.env.NODE_ENV === 'development',
  
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  
  detection: {
    // Language is now stored in the user table in the database.
    // It is applied after login via AuthContext.
    // We keep 'navigator' as a fallback for unauthenticated pages (login, forgot-password).
    order: ['navigator'],
    caches: []
  }
};

// Initialize i18n
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init(initOptions);

export default i18n;